/** Calculate duration in seconds from a finishedAt ISO timestamp to now */
export const calcRemainingSeconds = (finishedAt: string) => {
  const ms = new Date(finishedAt).getTime();
  if (Number.isNaN(ms)) return 0;
  return Math.floor((ms - Date.now()) / 1000);
};

/** Format seconds to "MM:SS" display string */
export const formatSecondsToTime = (seconds: number | null): string => {
  if (seconds === null || seconds <= 0) return "00:00";
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};
